var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"top-cover",class:{'with-cover':_vm.option.withCover},style:({'background-image': ("url(" + (_vm.option.cover) + ")")}),attrs:{"data-title":_vm.option.title || _vm.$route.meta.title}})}
var staticRenderFns = []

export { render, staticRenderFns }